<section class="trips-container">
  <div class="trips-container__list" appSwiper [swiperOptions]="swiperOptions">
    <div class="swiper-wrapper">
      @if (isFetching) {
        @for (trip of fetchingTrips; track $index) {
          <ng-container
            [ngTemplateOutlet]="cardTemplate"
            [ngTemplateOutletContext]="{trip: null}"
          ></ng-container>
        }
      } @else {
        @for (trip of trips; track $index) {
          <ng-container
            [ngTemplateOutlet]="cardTemplate"
            [ngTemplateOutletContext]="{trip}"
          ></ng-container>
        }
      }
    </div>
  </div>
</section>

<ng-template let-trip="trip" #cardTemplate>
  <div class="swiper-slide trips-container__item">
    <app-trip-card
      [trip]="trip"
      [showButtonAction]="true"
      [buttonText]="'Explore'"
      [isFetching]="isFetching"
    ></app-trip-card>
  </div>
</ng-template>
